import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';

// Actions
import { getMe } from '../../../redux/modules/auth';

// Utils
import { FormattedMessage } from '../../../utils/i18n';

// Constants
import { NAV_PATHS } from '../../../utils/constants';

// Enums
import { TwoFactorEnableSteps } from '../../../redux/modules/types/two-factor-auth';

// Components
import { TwoFactorAuthFlow } from './2fa';
import User from '@/types/user';

type DispatchProps = {
  getMe: (contextId?: string) => Promise<User>;
};

type Props = DispatchProps & RouteComponentProps<any, any, any>;

export class Setup2FA extends Component<Props> {
  render() {
    const {
      location: {
        state: { from, canSkipUntil },
      },
    } = this.props;
    const initStepFeedback = from === `${NAV_PATHS.AUTH}/set-password` && (
      <>
        <span className="icon-checkmark" />
        <span>
          <FormattedMessage id="TwoFactorAuthentication.Texts.AccountCreated" />
        </span>
      </>
    );
    const skipSetup = canSkipUntil ? async () => this.props.getMe() : undefined;
    const gracePeriod = moment(canSkipUntil).startOf('day').diff(moment().startOf('day'), 'day');

    return (
      <div className="two-factor-container auth-page">
        <TwoFactorAuthFlow
          gracePeriod={gracePeriod}
          initStep={TwoFactorEnableSteps.MANDATORY_SETUP}
          initStepFeedback={initStepFeedback}
          onCancel={skipSetup}
          onDone={async () => {
            await this.props.getMe();
          }}
        />
      </div>
    );
  }
}

export default withRouter(connect(null, { getMe })(Setup2FA));
